export default {
    'discover-app': 'Jesteś już tutaj jakiś czas, czy wiesz o tym że mamy własną aplikację na telefony z systemem Android? Nie? Koniecznie musisz to sprawdzić!',
    'go-to-google-play': 'Przejdź do Google Play'
}
